import { useSelector } from 'react-redux';
import { Cell, DeprecatedIcon, Text, Validation } from '@vinted/web-ui';
import useTranslate from 'hooks/useTranslate';
import ContentLoader from 'components/ContentLoader';
import { CreditCard } from 'components/CreditCardList';
import { PayInMethod } from 'components/PayInMethodSelection';
import { ClickableCreditCardItemType } from 'components/CreditCardList/types';
import { getLocale } from 'state/intl/selectors';
import { formatCurrencyAmount } from 'libs/utils/formatString';
import { PayInMethodCode } from 'constants/pay-in-method';
import { jsx as _jsx } from "react/jsx-runtime";

const ExtraServiceActivePayInMethod = _ref => {
  let {
    isLoading = false,
    error,
    walletBalance,
    activePayInMethod,
    selectedCreditCard,
    onPaymentMethodSelect
  } = _ref;
  const translate = useTranslate('payment_method_selection');
  const locale = useSelector(getLocale);

  function renderPayInMethodBody() {
    if ((activePayInMethod === null || activePayInMethod === void 0 ? void 0 : activePayInMethod.code) === PayInMethodCode.Trustly) return activePayInMethod.note;

    if ((activePayInMethod === null || activePayInMethod === void 0 ? void 0 : activePayInMethod.code) === PayInMethodCode.Wallet && walletBalance) {
      const {
        availableAmount
      } = walletBalance;
      return /*#__PURE__*/_jsx(Text, {
        text: translate('notes.wallet', {
          balance: formatCurrencyAmount(availableAmount, locale)
        })
      });
    }

    return null;
  }

  function renderSuffix() {
    return /*#__PURE__*/_jsx(DeprecatedIcon, {
      name: "pencil",
      color: DeprecatedIcon.Color.GreyscaleLevel3,
      testId: "extra-service-active-pay-in-method-pencil-icon"
    });
  }

  function renderEmptyPayInMethod() {
    return /*#__PURE__*/_jsx(Cell, {
      title: translate('choose_payment_method'),
      suffix: /*#__PURE__*/_jsx(DeprecatedIcon, {
        name: "plus",
        aria: {
          'aria-hidden': 'true'
        }
      }),
      validation: error && /*#__PURE__*/_jsx(Validation, {
        text: error,
        theme: "warning"
      }),
      type: Cell.Type.Navigating,
      styling: Cell.Styling.Wide,
      testId: "extra-service-active-pay-in-method-choose-payment-method",
      onClick: onPaymentMethodSelect
    });
  }

  if (isLoading) {
    return /*#__PURE__*/_jsx(ContentLoader, {
      testId: "extra-service-active-pay-in-method-loader"
    });
  }

  if (selectedCreditCard) {
    return /*#__PURE__*/_jsx(CreditCard, {
      card: selectedCreditCard,
      clickableType: ClickableCreditCardItemType.AlwaysClickable,
      onClick: onPaymentMethodSelect,
      suffix: renderSuffix()
    });
  }

  if (activePayInMethod) {
    return /*#__PURE__*/_jsx(PayInMethod, {
      body: renderPayInMethodBody(),
      payInMethod: activePayInMethod,
      onClick: onPaymentMethodSelect,
      suffix: renderSuffix()
    });
  }

  return renderEmptyPayInMethod();
};

export default ExtraServiceActivePayInMethod;